import React, { useEffect } from 'react';
import { SliceWrapper } from '../slices/SliceWrapper';

interface IProps {
  url: string;
}

export function Buzzsprout({ url }: IProps) {
  const id = 'buzzsprout-player';
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${url}.js?container_id=${id}&player=small`;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url, id]);
  return <SliceWrapper left={<div id={id}></div>} isArticle />;
}
